import { t } from "@/i18n-js/instance";
import { useSelectedBlock } from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";
import { Icon } from "@circle-react-shared/Icon";
import { BlockActionButton } from "./BlockActionButton";

export const Duplicate = () => {
  const { isDuplicateable, duplicateSelectedBlock } = useSelectedBlock();

  return (
    <BlockActionButton
      onClick={duplicateSelectedBlock}
      disabled={!isDuplicateable}
      title={t("builder_ui.editor.duplicate")}
    >
      <Icon type="16-copy" size={16} />
    </BlockActionButton>
  );
};
